var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-testimonial"},[_c('div',{staticClass:"grid__item"},[_c('div',{staticClass:"basic-testimonial-wrap"},[_c('div',{staticClass:"basic-testimonial__content"},[_vm._t("quote")],2),_c('div',{staticClass:"basic-testimonial__attribution"},[_vm._t("attribution")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }